import ContactFormSection from "../Components/ContactFormSection";
import ericNurPortrait from "../assets/eric-nur-portrait.jpeg";

const credentials = [
  "Broker/Owner and President of American Realty Network LLC, Rental Masters LLC.",
  "Licensed Real Estate Salesman since 1989.",
  "Licensed Real Estate Broker since 1992.",
  "Licensed Mortgage Broker (1992 - 2012).",
  "Licensed and Registered Real Estate Appraiser (1993-2001).",
  "Licensed Real Estate Instructor (1991-1999)",
  "Bachelor of Science degree in Physics, ODTU (METU), Ankara, Turkey, 1980.",
  "Masters degree in Computer Science (MCS), FAU, Boca Raton, FL, USA, in 1988.",
  "Masters degree in Business Administration (MBA), NYIT, NY, USA, in 1995.",
  "Successfully completed Chamber of Commerce Leadership program (2002).",
];

const associations = [
  "Miami Association of Realtors.",
  "Miami Multiple Listing Service (Miami MLS).",
  "Fort Lauderdale Association of Realtors.",
  "Fort Lauderdale Multiple Listing Service (Fort Lauderdale MLS).",
  "Florida Association of Realtors.",
  "National Association of Realtors.",
  "International Business Council.",
  "Greater Miami Chamber of Commerce.",
  "Better Business Bureau.",
  
];

function EricNur() {
  return (
    <div className="section-wrap py-10 lg:py-14">
      <section className="grid gap-6 xl:grid-cols-[minmax(0,1.35fr)_minmax(360px,0.65fr)]">
        <article className="premium-panel p-7 sm:p-10">
          <div className="mb-6 overflow-hidden">
            <img
              src={ericNurPortrait}
              alt="Eric Erkan Nur"
              className="mx-auto mb-4 h-[300px] w-full max-w-[250px] rounded-[1rem] border border-obsidian-200 bg-white object-cover object-top shadow-cream sm:h-[340px] sm:max-w-[290px] lg:float-right lg:mb-3 lg:ml-8 lg:h-[320px] lg:max-w-[270px] xl:h-[340px] xl:max-w-[290px]"
            />

            <h1 className="mt-3 font-serif text-4xl leading-tight text-obsidian-950">ERIC ERKAN NUR</h1>
            <p className="mt-5 text-sm leading-7 text-obsidian-700">
              I am the President and Owner/Broker at American Realty Network. I have been serving South
              Florida residents and the business community more than 35 years. In addition to my extensive
              experience in selling, renting and managing residential and commercial real estate, I am holding
              licenses practically in every aspect of real estate business. I also hold Masters degrees in
              Business Administration (MBA) and Computer Science (MCS):
            </p>
          </div>

          <div className="mt-6 rounded-2xl border border-obsidian-200 bg-cream-50 p-5">
            <ul className="space-y-2 text-sm leading-7 text-obsidian-700">
              {credentials.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <p className="mt-6 text-sm leading-7 text-obsidian-700">
            I am an active member of the following trade and charitable associations:
          </p>

          <div className="mt-4 rounded-2xl border border-obsidian-200 bg-cream-50 p-5">
            <ul className="space-y-2 text-sm leading-7 text-obsidian-700">
              {associations.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            
          </div>
          <p className="mt-6 text-sm leading-7 text-obsidian-700">
            I can be reached at the following number/email address:
          </p>
          <ul className="space-y-2 text-sm leading-7 text-obsidian-700">
              
                <li>+1 (561) 702-3795 (Mobile)</li>
                <li>Miami23@EricNur.com (E-mail)</li>
              
            </ul>
          
        </article>

        <aside>
          <ContactFormSection
            title="CONTACT FORM"
            
            className="xl:sticky xl:top-28"
          />
        </aside>
      </section>

      
    </div>
  );
}

export default EricNur;
